import React, { useCallback, useState, useEffect, Fragment, useMemo, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { CardBody, Row,
    Table, Input, Button,
    Nav, NavItem, NavLink
  } from "reactstrap";
  import { createSelector } from "reselect";
import classnames from "classnames";
import { debounce } from "lodash";
import { getPartsPaged, getPart, updatePart, publish } from "../../slices/thunks";
import NoResults from "./NoResults";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const PartsTable = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [searchValue, setSearchValue] = useState("");
    const [searchField, setSearchField] = useState("");

    const [catalogSearch, setCatalogSearch] = useState("");
    const refCatalog = useRef();
    const onChangeCatalog = () => {
        setNameSearch("");
        setIdSearch("");
        setSearchValue(catalogSearch);
        setSearchField("CatalogNumber");
        const request = { page: 1, size: 25, statusFilter: activeTab, searchInput: catalogSearch, searchField: "CatalogNumber" };
        sessionStorage.setItem("pageRequest", JSON.stringify(request));
        dispatch(getPartsPaged(request));
    };
    useEffect(() => { refCatalog.current = onChangeCatalog; }, [onChangeCatalog]);
    const debouncedCallbackCatalog = useMemo(() => debounce(() => refCatalog.current?.(), 1000), []);
    
    const [nameSearch, setNameSearch] = useState("");
    const ref = useRef();
    const onChange = () => {
        setCatalogSearch("");
        setIdSearch("");
        setSearchValue(nameSearch);
        setSearchField("Name");
        const request = { page: 1, size: 25, statusFilter: activeTab, searchInput: nameSearch, searchField: "Name" };
        sessionStorage.setItem("pageRequest", JSON.stringify(request));
        dispatch(getPartsPaged(request));
    };
    useEffect(() => { ref.current = onChange; }, [onChange]);
    const debouncedCallback = useMemo(() => debounce(() => ref.current?.(), 1000), []);
    
    const [idSearch, setIdSearch] = useState("");
    const refId = useRef();
    const onChangeId = () => {
        setNameSearch("");
        setCatalogSearch("");
        setSearchValue(idSearch);
        setSearchField("PublicIdentifier");
        const request = { page: 1, size: 25, statusFilter: activeTab, searchInput: idSearch, searchField: "PublicIdentifier" };
        sessionStorage.setItem("pageRequest", JSON.stringify(request));
        dispatch(getPartsPaged(request));
    };
    useEffect(() => { refId.current = onChangeId; }, [onChangeId]);
    const debouncedCallbackId = useMemo(() => debounce(() => refId.current?.(), 1000), []);
    
    const storeProperties = createSelector((state) => state.Part, (state) => ({
        pagedParts: state.pagedParts,
        paginationInfo: state.paginationInfo,
        pageRequest: state.pageRequest,
        suggestedPrices: state.suggestedPrices,
        error: state.error,
    }));

    const { pagedParts, paginationInfo, pageRequest, suggestedPrices, error } = useSelector(storeProperties);

    const user = JSON.parse(sessionStorage.getItem("authUser"));
    const isAdmin = user.role == 'Admin' ? true : false;   

    const [partList, setPartList] = useState([]);
    const [prices, setPrices] = useState(JSON.parse(sessionStorage.getItem("suggestedPrices")));
    const [commonPrices, setCommonPrices] = useState(JSON.parse(sessionStorage.getItem("suggestedPrices")));
    
    const [activeTab, setActiveTab] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);

    const toggleActiveTab = (tab) => {
        setActiveTab(tab);
        const request = { page: 1, size: 25, statusFilter: tab, searchInput: pageRequest.searchInput, searchField: pageRequest.searchField };
        sessionStorage.setItem("pageRequest", JSON.stringify(request));
        dispatch(getPartsPaged(request));
    };
    
    const handlePageChange = (page) => {
        setCurrentPage(page);
        const request = { page: page, size: 25, statusFilter: activeTab, searchInput: pageRequest.searchInput, searchField: pageRequest.searchField };
        sessionStorage.setItem("pageRequest", JSON.stringify(request));
        dispatch(getPartsPaged(request));
    };

    useEffect(() => {
        dispatch(getPartsPaged(pageRequest));
        setPartList(pagedParts);
        if(pageRequest.searchField == "CatalogNumber"){
            setCatalogSearch(pageRequest.searchInput);
        }else if(pageRequest.searchField == "Name"){
            setNameSearch(pageRequest.searchInput);
        }
        else if(pageRequest.searchField == "PublicIdentifier"){
            setIdSearch(pageRequest.searchInput);
        }
    }, []);

    useEffect(() => {
        setPartList(pagedParts);
        setCurrentPage(paginationInfo.currentPage);
        setActiveTab(pageRequest.statusFilter);
        setCommonPrices(JSON.parse(sessionStorage.getItem("suggestedPrices")));        
    }, [pagedParts]);

    const onChangeHandle = (newPrice, part) => { 
        if (part.sellingPrice === newPrice) return;
        let updatedPart = {...part, status: 1, sellingPrice: newPrice};
        dispatch(updatePart(updatedPart));
        const prices = commonPrices.find(item => item === newPrice);
        if (!prices) {
            const newPrices = [newPrice, commonPrices[0], commonPrices[1]];
            setCommonPrices(newPrices);
            sessionStorage.setItem("suggestedPrices", JSON.stringify(newPrices));
        }               
    };

    const onRowClick = (part) =>{
        sessionStorage.setItem("partDetails", JSON.stringify(part));
        dispatch(getPart(part.id));
        navigate("/part-details");
    };

    const printLabel = (part) => {
        // Create a new window for printing
        const printWindow = window.open('', '_blank', 'width=400,height=600');
        
        if (printWindow) {
            printWindow.document.write(`
                <!DOCTYPE html>
                <html>
                <head>
                    <title>Label - ${part.publicIdentifier}</title>
                    <style>
                        @media print {
                            @page {
                                size: 58mm auto;
                                margin: 2mm;
                            }
                            body {
                                margin: 0;
                                padding: 0;
                            }
                        }
                        body {
                            font-family: 'Courier New', monospace;
                            font-size: 10pt;
                            line-height: 1.2;
                            margin: 0;
                            padding: 5mm;
                            width: 58mm;
                        }
                        .header {
                            font-weight: bold;
                            font-size: 12pt;
                            text-align: center;
                            border-top: 2px solid #000;
                            border-bottom: 2px solid #000;
                            padding: 2mm 0;
                            margin: 2mm 0;
                        }
                        .field {
                            margin: 2mm 0;
                            border-bottom: 1px dashed #000;
                            padding-bottom: 1mm;
                        }
                        .label-title {
                            font-weight: bold;
                            font-size: 8pt;
                        }
                        .label-value {
                            font-size: 10pt;
                            margin-top: 1mm;
                        }
                    </style>
                </head>
                <body>
                    <div class="label">
                        <div class="header">ID: ${part.publicIdentifier}</div>
                        <div class="field">
                            <div class="label-title">NAZIV:</div>
                            <div class="label-value">${part.name}</div>
                        </div>
                        <div class="field">
                            <div class="label-title">KAT BROJ:</div>
                            <div class="label-value">${part.catalogNumber || 'N/A'}</div>
                        </div>
                        <div class="field">
                            <div class="label-title">STRANA:</div>
                            <div class="label-value">${part.location || 'N/A'}</div>
                        </div>
                        <div class="field">
                            <div class="label-title">BOJA:</div>
                            <div class="label-value">${part.color || 'N/A'}</div>
                        </div>
                    </div>
                </body>
                </html>
            `);
            
            printWindow.document.close();
            
            // Wait for content to load then print
            printWindow.onload = function() {
                setTimeout(() => {
                    printWindow.print();
                    // Close window after printing dialog closes
                    setTimeout(() => {
                        printWindow.close();
                    }, 100);
                }, 250);
            };
        } else {
            alert('Molimo omogućite pop-up prozore za printanje.');
        }
    };

    const handlePublishClick = (partId) => {
        dispatch(publish({id: partId, isVehicle: false}));
    };
  const handleCopyToClipboard = async (part) => {
    await navigator.clipboard.writeText("https://olx.ba/artikal/" + part.listingId);
    toast.info("Link kopiran.");
  };
    return (
        <Fragment>
            <CardBody className="pt-0">
                <Nav className="nav-tabs nav-tabs-custom nav-success">
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab == 1 }, "fw-semibold")} onClick={() => {toggleActiveTab(1)}}> Dostupni </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab == 2 }, "fw-semibold")} onClick={() => {toggleActiveTab(2)}}> Nedostupni </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab == 3 }, "fw-semibold")} onClick={() => {toggleActiveTab(3)}}> Na čekanju </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={classnames({ active: activeTab == 4 }, "fw-semibold")} onClick={() => {toggleActiveTab(4)}}> Prodani </NavLink>
                    </NavItem>
                </Nav>
            </CardBody>
            <Row className="mb-3">
                <CardBody className="border border-dashed border-end-0 border-start-0">
                    <Row style={{ display: "flex", justifyContent: "center" }}>
                        <div className="search-box me-2 mb-2 col-2">
                            <Input name="idSearch" type="search" className="form-control search"
                                placeholder="ID BROJ"
                                value={idSearch}
                                onChange={(e) => { debouncedCallbackId(); setIdSearch(e.target.value); }}/>
                            <i className="bx bx-search-alt search-icon ps-2" />
                        </div>
                        <div className="search-box me-2 mb-2 col-6">
                            <Input name="search" type="search" className="form-control search"
                                placeholder="NAZIV DIJELA"
                                value={nameSearch}
                                onChange={(e) => { debouncedCallback(); setNameSearch(e.target.value); }}/>
                            <i className="bx bx-search-alt search-icon ps-2" />
                        </div>
                        <div className="search-box me-2 mb-2 col-2">
                            <Input name="catalogSearch" type="search" className="form-control search"
                                placeholder="KATALOŠKI BROJ"
                                value={catalogSearch}
                                onChange={(e) => { debouncedCallbackCatalog(); setCatalogSearch(e.target.value); }}/>
                            <i className="bx bx-search-alt search-icon ps-2" />
                        </div>                                            
                    </Row>
                </CardBody>
            </Row>
                    <CardBody className="pt-0">
                        {(!partList || !partList.length) ? ( <NoResults /> ) : 
                            (<div className="table-responsive table-card mb-1">
                                <Table hover className="align-middle table-nowrap">
                                    <thead className="table-light text-muted text-uppercase align-content-center">
                                        <tr>
                                            <th>Id broj</th>
                                            <th>Naziv</th>
                                            <th>Kataloški broj</th>
                                            <th>Lokacija</th>
                                            <th>Status</th>
                                            <th>OLX</th>
                                            <th>Cijena</th>
                                            <th className="text-center">Label</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {partList.map(part => (
                                        <tr key={part.id}>
                                            <td style={{width: 50}} onClick={() => onRowClick(part)}>
                                                <h5 className="fs-14 text-uppercase text-center mb-1">{part.publicIdentifier}</h5>
                                            </td>
                                            <td onClick={() => onRowClick(part)}>
                                                <div className="d-flex align-items-center">
                                                    <div className="flex-shrink-0 me-3">
                                                        <div className="bg-light rounded overflow-hidden" style={{width: 100, height: 80}}>
                                                            <img src={part.images[0].thumbnailUrl} alt="img-thumbnail" className="d-block img-thumbnail" />
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <h5 className="fs-14 mb-1">{part.name}</h5>
                                                    </div>
                                                </div>
                                            </td>
                                            <td onClick={() => onRowClick(part)}>
                                                <h5 className="fs-14 mb-1">{part.catalogNumber}</h5>
                                            </td>
                                            <td onClick={() => onRowClick(part)}><h5 className="fs-14 mb-1">{part.location}</h5></td>
                                            <td onClick={() => onRowClick(part)}>{ 
                                            part.status == 1 && (<span className="badge rounded-pill border border-success text-uppercase text-success"> Dostupno </span>)
                                            || part.status == 2 && (<span className="badge rounded-pill border border-danger text-uppercase text-danger"> Nedostupno </span>)
                                            || part.status == 3 && (<span className="badge rounded-pill border border-warning text-uppercase text-warning"> Na čekanju </span>) 
                                            || part.status == 4 && (<span className="badge rounded-pill border border-primary text-uppercase text-primary"> Prodano </span>)
                                            }</td>
                                            <td>
                                            {part.listingId != null && (
                                                <div className="hstack justify-content-start">
                                                        <Button color='primary' outline onClick={() => {handleCopyToClipboard(part)}}><i className="ri-clipboard-line fs-14" /></Button>
                                                    </div>)}
                                                {(isAdmin && part.listingId == null && part.status == 1) && (
                                                    <div className="hstack justify-content-start">
                                                        <Button color='primary' outline onClick={() => {handlePublishClick(part.id)}}>OLX</Button>
                                                    </div>
                                                )}
                                            </td>
                                            {!isAdmin ? (
                                                <td onClick={() => onRowClick(part)}>
                                                    <h5 className="fs-14 mb-1">{part.sellingPrice + " KM"}</h5>
                                                </td>
                                                ) : (
                                            <td style={{width: 150}}>
                                            <div className="btn-group btn-group-md gap-2 mb-2">
                                                {commonPrices.map((price, key) => (<Button key={key} color="primary" className="btn-icon" outline onClick={() => onChangeHandle(price, part)}>{price}</Button>))} 
                                            </div>
                                            <Input name="sellingPrice" type="number" className="form-control"
                                                placeholder="CIJENA"
                                                value={part.sellingPrice || ""}
                                                onChange={(e) => onChangeHandle(e.target.value, part)} />
                                            </td>)
                                        }
                                        <td className="text-center" style={{width: 80}}>
                                            <Button 
                                                color="info" 
                                                size="sm" 
                                                outline
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    printLabel(part);
                                                }}
                                                title="Printaj Label"
                                            >
                                                <i className="ri-printer-line" />
                                            </Button>
                                        </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </div>)}
                <div className="hstack gap-3 justify-content-center">
                    {currentPage <= 1 ? 
                        (<button className="page-item pagination-prev disabled">Prethodna</button>) : 
                        (<button className="page-item pagination-prev" onClick={() => handlePageChange(currentPage - 1)}>Prethodna</button>)
                    }
                    <div className="vr"></div>
                    {currentPage >= paginationInfo.totalPages ? 
                        (<button className="page-item pagination-prev disabled">Sljedeća</button>) : 
                        (<button className="page-item pagination-prev" onClick={() => handlePageChange(currentPage + 1)}>Sljedeća</button>)
                    }
                </div>
                <h5 className="mt-4 text-center">{ "Stranica " + currentPage + " od " + paginationInfo.totalPages}</h5>
            </CardBody>
        </Fragment>
    );
};

export default PartsTable;